/**
 * Resolución del modo de la app por HOST, mismo patrón que quiosco:
 *
 *   miensamble.com / www.miensamble.com → sitio público (landing)
 *   app.miensamble.com                  → la aplicación (login + cancionero)
 *   localhost                           → la aplicación; la landing se prueba
 *                                         en la ruta /landing
 *
 * En producción el dominio se fija igual que la URL del API en axios.ts.
 */
export const SITE_DOMAIN =
  process.env.NODE_ENV === 'production'
    ? 'miensamble.com'
    : process.env.REACT_APP_SITE_DOMAIN || '';

/** ¿El host actual es el apex (miensamble.com o www) → sitio público? */
export function isLandingHost(): boolean {
  if (!SITE_DOMAIN) return false;
  const host = window.location.hostname;
  return host === SITE_DOMAIN || host === 'www.' + SITE_DOMAIN;
}

/** Enlace a la aplicación (subdominio en producción, ruta en local). */
export function appUrl(path = '/login'): string {
  return SITE_DOMAIN ? `https://app.${SITE_DOMAIN}${path}` : path;
}

export const CONTACT_EMAIL = 'contacto@rzoftware.com';

/**
 * Correo para pedir una cuenta. Va aparte del de contacto porque es el que se
 * publica en la web y el que la gente escribirá al ver el demo.
 */
export const VENTAS_EMAIL = 'ventas@miensamble.com';
